import React, { useEffect, useState } from "react";
import Navbar from "../SharePages/Navbar/Navbar";
import SideNavBar from "../SharePages/SideNavBar/SideNavBar";
import { toast, ToastContainer } from "react-toastify";
import Footer from "../SharePages/Footer/Footer";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Text,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { FaChevronCircleDown } from "react-icons/fa";
import { FaChevronCircleUp } from "react-icons/fa";
import {
  acceptFareChangeQuotation,
  getDataForQuotationViewForFare,
  rejectFareChangeQuotation,
} from "../../common/allApi";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import CountdownTimerRefund from "./countdown";

const Quotation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [agree, setAgree] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [toggle, setToggle] = useState(true);
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  let [fareQuotationTicketingView, setFareQuotationTicketingView] = useState(
    []
  );
  const [summary, setSummary] = useState();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const ItemState = searchParams.get("failedAuto");
    if (ItemState === "true") {
      onOpen1();
    }
  }, [searchParams, onOpen1]);

  const getQuotationTicketingView = async () => {
    setLoader(true);
    try {
      const response = await getDataForQuotationViewForFare(
        searchParams.get("id")
      );

      if (response?.data?.isSuccess) {
        setFareQuotationTicketingView(response?.data?.data?.data);
        setLoader(false);
      }
      setLoader(false);
    } catch (error) {
      toast.error("Please try again.");
      setLoader(false);
    }
  };

  const [disabled, setIsdisabled] = useState(false);
  const handelFareQuotationAccept = async () => {
    setIsdisabled(true);
    try {
      const response1 = await getDataForQuotationViewForFare(
        searchParams.get("id")
      );

      console.log(response1,'response1======')
      if(fareQuotationTicketingView?.totalPrice == response1?.data?.data?.data?.totalPrice){
         const response = await acceptFareChangeQuotation(searchParams.get("id"));
      if (response?.data?.isSuccess) {
        onClose();
        if (response.data?.data?.failedAuto) {
          onOpen2();
        } else {
          navigate("/fare-change-quotation");
          toast.success(response?.data?.message);
        }
        setIsdisabled(false);
      } else {
        toast.error(response?.data?.message);
        setIsdisabled(false);
      }
      }
      else{
        toast.error("Fare Quotation has been changed, please try again.");
         onClose();
          setIsdisabled(false);
           setFareQuotationTicketingView(response1?.data?.data?.data);

      }

     
    } catch (error) {
      toast.error("Please try again.");
      setIsdisabled(false);
    }
  };

  const [isRejecet, setIsReject] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const handelFareQuotationReject = async () => {
    setIsReject(true);
    try {
      let payload = {
        fairChangeRequestId: searchParams.get("id"),
        rejectionReason: rejectionReason,
      };
      const response = await rejectFareChangeQuotation(payload);
      if (response?.data?.isSuccess) {
        onClose();
        getQuotationTicketingView();
        navigate("/fare-change-quotation");
        // toast.success(response?.message);
      } else {
        setIsReject(false);
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setIsReject(false);
      toast.error("Please try again.");
    }
  };
  useEffect(() => {
    getQuotationTicketingView();
  }, []);
  return (
    <div>
      <Navbar></Navbar>
      <SideNavBar></SideNavBar>
      <div className="content-wrapper search-panel-bg">
        <ToastContainer position="bottom-right" autoClose={1500} />
        <section className="content-header"></section>
        <section className="content pb-5">
          <div className="container-fluid pt-2">
            <div className="row mx-lg-4 mx-md-4 mx-sm-1">
              <div className="col-lg-12 px-0">
                <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-white shadow rounded">
                  <span className="fw-bold">Fare Quotation Change</span>
                </div>
              </div>
            </div>
            <div className="row mx-lg-4 mx-md-4 mx-sm-1 my-3">
              <div className="col-lg-8 box-shadow bg-white rounded">
                <div className="row bg-light rounded">
                  <div className="d-flex justify-content-start align-items-center py-2 gap-3">
                    <div className="fw-bold">
                      Fare Change {fareQuotationTicketingView?.routes}
                    </div>
                    <button
                      type="button"
                      className="btn text-white fw-bold border-radius"
                      style={{ background: "#068B9F" }}
                    >
                      {fareQuotationTicketingView?.status}
                    </button>
                  </div>
                </div>
                <div className="pb-5">
                  <div className="row bg-light m-2 rounded">
                    <div className="py-2">
                      <div>
                        Quotation expire in :{" "}
                        {fareQuotationTicketingView?.expireInMinutes ? (
                          <button
                            type="button"
                            className="btn btn-danger text-white fw-bold rounded-pill px-3"
                            style={{ fontSize: "12px" }}
                          >
                            {fareQuotationTicketingView?.status == "Quoted" ? (
                              <CountdownTimerRefund
                                expireMinutes={
                                  fareQuotationTicketingView &&
                                  fareQuotationTicketingView?.expireInMinutes
                                }
                              />
                            ) : (
                              <>{fareQuotationTicketingView?.status}</>
                            )}
                          </button>
                        ) : (
                          <span className="fw-bold">N/A</span>
                        )}
                      </div>
                      <div>
                        <p style={{ color: "red" }}>
                          Please check the following quotation
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row m-2">
                    <div className="table-responsive px-0">
                      <table
                        className="table table-bordered my-2 mb-3"
                        style={{ fontSize: "14px" }}
                      >
                        <tbody>
                          <tr>
                            <th>booking Id</th>
                            <td>{fareQuotationTicketingView?.uniqueTransId}</td>
                            <td className="fw-bold">PNR</td>
                            <td>{fareQuotationTicketingView?.pnr}</td>
                          </tr>

                          <tr>
                            <th>Requested Status</th>
                            <td>
                              {fareQuotationTicketingView?.status
                                ? fareQuotationTicketingView.status
                                : "N/A"}
                            </td>
                            <td className="fw-bold">Agency Name</td>
                            <td>
                              {fareQuotationTicketingView?.agentName
                                ? fareQuotationTicketingView.agentName
                                : "N/A"}
                            </td>
                          </tr>

                          <tr>
                            <th>Fly Date</th>
                            <td>
                              {fareQuotationTicketingView?.flightDate !== null
                                ? moment(
                                    fareQuotationTicketingView?.flightDate
                                  ).format("DD-MMMM-yyyy")
                                : "N/A"}
                            </td>
                            <td className="fw-bold">Quotation Created Date</td>
                            <td>
                              {fareQuotationTicketingView?.createdDate !== null
                                ? moment(
                                    fareQuotationTicketingView?.createdDate
                                  ).format("DD-MMMM-yyyy")
                                : "N/A"}
                            </td>
                          </tr>

                          <tr>
                            <th>Airline Code</th>
                            <td>
                              {fareQuotationTicketingView?.platingCarrier}
                            </td>

                            <td className="fw-bold">Latest Update On</td>
                            <td>
                              {moment(
                                fareQuotationTicketingView?.expireDate
                              ).format("DD-MMMM-yyyy")}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {loader ? (
                    <div className="d-flex align-items-center justify-content-center my-3">
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {fareQuotationTicketingView?.fareChangeQuotationDetails
                        ?.length > 0 &&
                        fareQuotationTicketingView?.fareChangeQuotationDetails?.map(
                          (item, index) => {
                            return (
                              <div
                                className="row m-2 bg-light rounded"
                                key={index}
                              >
                                <div className="d-flex justify-content-between align-items-center pt-3">
                                  <div>Fare Breakdown</div>
                                  {/* {toggle ? (
                                    <FaChevronCircleUp
                                      onClick={() => setToggle((pre) => !pre)}
                                    />
                                  ) : (
                                    <FaChevronCircleDown
                                      onClick={() => setToggle((pre) => !pre)}
                                    />
                                  )} */}
                                </div>
                                <div className="py-2 table-responsive">
                                  {toggle && (
                                    <table
                                      className="table table-lg"
                                      style={{
                                        width: "100%",
                                        fontSize: "13px",
                                      }}
                                    >
                                      <thead className="text-start fw-bold bg-secondary">
                                        <tr>
                                          <th>PASSENGER TYPE</th>
                                          <th className="text-end">
                                            BASE FARE
                                          </th>
                                          <th className="text-end">TAX</th>
                                          <th className="text-end">AIT</th>
                                          {/* <th className="text-end">MARKUP</th> */}
                                          <th className="text-end">DISCOUNT</th>
                                          <th className="text-end">TOTAL</th>
                                          <th>TOTAL PASSENGER</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr className="text-start fw-bold text-secondary">
                                          <td>{item?.paxType}</td>
                                          <td className="text-end text-dark">
                                            BDT{" "}
                                            {item?.basePrice?.toLocaleString(
                                              "en-US"
                                            )}
                                          </td>
                                          <td className="text-end text-dark">
                                            BDT{" "}
                                            {item?.tax?.toLocaleString("en-US")}
                                          </td>
                                          <td className="text-end text-dark">
                                            BDT{" "}
                                            {item?.ait?.toLocaleString("en-US")}
                                          </td>
                                          {/* <td className="text-end text-dark">
                                            BDT{" "}
                                            {item?.markUp?.toLocaleString(
                                              "en-US"
                                            )}
                                          </td> */}
                                          <td className="text-end text-dark">
                                            BDT{" "}
                                            {item?.discount?.toLocaleString(
                                              "en-US"
                                            )}
                                          </td>
                                          <td className="text-end text-dark">
                                            BDT{" "}
                                            {item?.total?.toLocaleString(
                                              "en-US"
                                            )}
                                          </td>
                                          <td>{item?.paxNum}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </div>
                            );
                          }
                        )}
                    </>
                  )}
                </div>
              </div>
              <div className="col-lg-4">
                <div className=" box-shadow bg-white rounded">
                  <Box
                    style={{ background: "#F8F9FA" }}
                    p={3}
                    fontWeight={700}
                    fontSize={"20px"}
                  >
                    Quotation Summary
                  </Box>
                  <div className="container row pt-3 pb-2 px-2">
                    <div style={{ color: "#67696a" }}>
                      <>
                        <div className="row mt-2" style={{ fontSize: "14px" }}>
                          <Flex
                            justifyContent={"space-between"}
                            lineHeight="1.8"
                          >
                            <Text fontWeight={600}>Total Base Price</Text>
                            {fareQuotationTicketingView?.totalBasePriceFare ? (
                              <Text>
                                {fareQuotationTicketingView?.totalBasePriceFare}
                                BDT
                              </Text>
                            ) : (
                              <Text color={"red"}>Waiting for Quotation</Text>
                            )}
                          </Flex>
                        </div>
                        <div className="row" style={{ fontSize: "14px" }}>
                          <Flex
                            justifyContent={"space-between"}
                            lineHeight="1.8"
                          >
                            <Text fontWeight={600}>Total Tax</Text>
                            {fareQuotationTicketingView?.totalTaxPrice ? (
                              <Text>
                                {fareQuotationTicketingView?.totalTaxPrice}BDT
                              </Text>
                            ) : (
                              <Text color={"red"}>Waiting for Quotation</Text>
                            )}
                          </Flex>
                        </div>
                        <div className="row" style={{ fontSize: "14px" }}>
                          <Flex
                            justifyContent={"space-between"}
                            lineHeight="1.8"
                          >
                            <Text fontWeight={600}>Total AIT</Text>

                            {fareQuotationTicketingView?.totalAIT ? (
                              <Text>
                                {fareQuotationTicketingView?.totalAIT}BDT
                              </Text>
                            ) : (
                              <Text color={"red"}>Waiting for Quotation</Text>
                            )}
                          </Flex>
                        </div>
                        {/* <div className="row" style={{ fontSize: "14px" }}>
                          <Flex
                            justifyContent={"space-between"}
                            lineHeight="1.8"
                          >
                            <Text fontWeight={600}>Total Markup</Text>

                            {fareQuotationTicketingView?.totalMarkUpAmount >
                            -1 ? (
                              <Text>
                                {fareQuotationTicketingView?.totalMarkUpAmount}
                                BDT
                              </Text>
                            ) : (
                              <Text color={"red"}>Waiting for Quotation</Text>
                            )}
                          </Flex>
                        </div> */}
                        <div className="row" style={{ fontSize: "14px" }}>
                          <Flex
                            justifyContent={"space-between"}
                            lineHeight="1.8"
                          >
                            <Text fontWeight={600}>Total Discount</Text>

                            {fareQuotationTicketingView?.totalDiscountAmount}
                          </Flex>
                        </div>
                        <div className="row" style={{ fontSize: "14px" }}>
                          <Flex
                            justifyContent={"space-between"}
                            color={"#068B9F"}
                            lineHeight="1.8"
                          >
                            <Text fontWeight={600}>Total Price</Text>

                            <Text>
                              {fareQuotationTicketingView?.totalPrice}BDT
                            </Text>
                          </Flex>
                        </div>
                      </>
                    </div>
                  </div>

                  <Box pb={4} px={3}>
                    <Text mb="8px">
                      Remarks:
                      <span style={{ color: "red" }}>
                        {" "}
                        {fareQuotationTicketingView?.adminRemarks
                          ? fareQuotationTicketingView?.adminRemarks
                          : "N/A"}
                      </span>
                    </Text>
                    {fareQuotationTicketingView?.status === "Quoted" && (
                      <Box
                        display={"flex"}
                        justifyContent={"flex-start"}
                        gap={3}
                      >
                        {" "}
                        <input
                          type="checkbox"
                          onChange={(e) => setAgree(e.target.checked)}
                        />
                        <Text fontWeight={700}>
                          I acknowledge the{" "}
                          <Link to={"/termandcondition"} target="_blank">
                            <u style={{ color: "#068b9f" }} className="fw-bold">
                              Terms & Conditions{" "}
                            </u>{" "}
                          </Link>
                        </Text>
                      </Box>
                    )}
                  </Box>
                  {fareQuotationTicketingView?.status === "Quoted" && (
                    <div className="row pb-3 px-3">
                      <div className="col-lg-6">
                        <button
                          onClick={() => handelFareQuotationAccept()}
                          disabled={disabled ? true : agree ? false : true}
                          type="button"
                          className="btn button-color text-white fw-bold border-radius w-100"
                        >
                          Accept
                        </button>
                      </div>
                      <div className="col-lg-6">
                        <button
                          onClick={() => onOpen()}
                          disabled={disabled ? true : agree ? false : true}
                          type="button"
                          className="btn button-secondary-color text-white fw-bold border-radius w-100"
                        >
                          Reject
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <AlertDialog
          motionPreset="slideInBottom"
          onClose={onClose}
          isOpen={isOpen}
          isCentered
        >
          <AlertDialogOverlay />

          <AlertDialogContent>
            <div className="pt-3 ">
              <AlertDialogHeader className="py-0">
                Fare Change Confirmation
              </AlertDialogHeader>
              {/* <AlertDialogCloseButton /> */}
            </div>

            <AlertDialogBody>
              Are you sure you want to reject this quotation? Please provide a
              reason:
              <Textarea
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                placeholder="Write rejection reason here*"
                size="sm"
                className="border-radius"
              />
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                isDisabled={isRejecet}
                colorScheme="orange"
                onClick={() => {
                  onClose();
                  setRejectionReason("");
                }}
              >
                Cancel
              </Button>
              <Button
                isDisabled={rejectionReason === "" ? true : false}
                ml={3}
                onClick={handelFareQuotationReject}
                style={{ backgroundColor: "#068b9f", color: "white" }}
              >
                Reject
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>

        <AlertDialog
          motionPreset="slideInBottom"
          onClose={onClose1}
          isOpen={isOpen1}
          isCentered
        >
          <AlertDialogOverlay />

          <AlertDialogContent>
            <AlertDialogCloseButton />
            <AlertDialogBody padding={5}>
              <Text
                color={"red"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                fontSize={"20px"}
                pt={5}
                pb={4}
                fontWeight={500}
              >
                Attention!!{" "}
              </Text>
              <Text className="text-justify">
                We regret to inform you that due to technical issues with the
                Supplier API, the automated refund process is currently
                unavailable. However, we are proceeding with your request
                through our Manual Refund process.
              </Text>
              <Text pt={2}>Thank you for your patience and understanding.</Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                onClick={onClose1}
                bg={"#068B9F"}
                _hover={"none"}
                color={"white"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>

        <AlertDialog
          motionPreset="slideInBottom"
          onClose={onClose2}
          isOpen={isOpen2}
          isCentered
        >
          <AlertDialogOverlay />

          <AlertDialogContent>
            <AlertDialogCloseButton />
            <AlertDialogBody padding={5}>
              <Text
                color={"red"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                fontSize={"20px"}
                pt={5}
                pb={4}
                fontWeight={500}
              >
                Attention!!{" "}
              </Text>
              <Text className="text-justify">
                We&apos;re facing a technical issue with the Supplier API but
                our team is working to complete your refund. Please wait or
                contact support if needed.
              </Text>
              <Text pt={2}>Thank you for your patience.</Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                onClick={onClose2}
                bg={"#068B9F"}
                _hover={"none"}
                color={"white"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Quotation;
